class HeaderMenu extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.content = this.summary.nextElementSibling;
    this.header = document.querySelector('.header');
    this.hoverMedia = window.matchMedia('(hover: hover) and (min-width: 990px)');
    this.closeDelayMs = 150;
    this.closeTimeout = null;
    this.onMouseEnter = this.open.bind(this);
    this.onMouseLeave = this.scheduleClose.bind(this);
    this.onSummaryClick = this.onSummaryClick.bind(this);

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    this.summary.addEventListener('click', this.onSummaryClick);

    this.bindHover();
    this.hoverMedia.addEventListener('change', this.bindHover.bind(this));
  }

  bindHover() {
    this.removeEventListener('mouseenter', this.onMouseEnter);
    this.removeEventListener('mouseleave', this.onMouseLeave);

    if (this.hoverMedia.matches) {
      this.addEventListener('mouseenter', this.onMouseEnter);
      this.addEventListener('mouseleave', this.onMouseLeave);
    }
  }

  onSummaryClick(event) {
    if (!this.hoverMedia.matches) return;
    event.preventDefault();
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.closeNow();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }

    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  cancelClose() {
    if (!this.closeTimeout) return;
    clearTimeout(this.closeTimeout);
    this.closeTimeout = null;
  }

  scheduleClose() {
    this.cancelClose();
    this.closeTimeout = setTimeout(() => this.closeNow(), this.closeDelayMs);
  }

  open() {
    this.cancelClose();

    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu === this) return;
      menu.cancelClose();
      menu.closeNow();
    });

    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', true);
    this.onToggle();
  }

  closeNow() {
    this.cancelClose();
    this.mainDetailsToggle.removeAttribute('open');
    this.summary.setAttribute('aria-expanded', false);
    this.onToggle();
  }
}

customElements.define('header-menu', HeaderMenu);
